import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "q-pa-md"
};
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TopInformationList = _resolveComponent("TopInformationList");
    const _component_TopMenuCard = _resolveComponent("TopMenuCard");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_TopLinkCard = _resolveComponent("TopLinkCard");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_TopInformationList),
            _createVNode(_component_TopMenuCard),
            (!_ctx.isMt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_q_card, { class: "bg-alpha" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                        _createElementVNode("div", { class: "text-h6 text-bold" }, "インフォメーション", -1)
                                    ]))]),
                                _: 1
                            }),
                            _createVNode(_component_q_separator),
                            _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_TopLinkCard)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "q-pa-lg" }, null, -1)),
                    _createElementVNode("div", {
                        innerHTML: _ctx.html.value
                    }, null, 8, _hoisted_2)
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }));
}
